
import { DaysInColumnController } from './days-in-column.controller'

function daysInColumn () {
  return {
    restrict: 'E',
    scope: {
      maxDays: '<',
      daysInColumn: '<'
    },
    templateUrl: '/workflow/directives/days-in-column/days-in-column.html?$$REVISION$$',
    controller: DaysInColumnController
  }
}

export { daysInColumn }
